import { render, staticRenderFns } from "./TaxCertificate.vue?vue&type=template&id=8b010b02&scoped=true"
import script from "./TaxCertificate.vue?vue&type=script&lang=js"
export * from "./TaxCertificate.vue?vue&type=script&lang=js"
import style0 from "./TaxCertificate.vue?vue&type=style&index=0&id=8b010b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b010b02",
  null
  
)

export default component.exports